import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let LinkPreviewOption: LazyOption = createLazyOption(
    {
        key: 'linkPreview',
        titleStringKey: 'optionTitle_linkPreview',
        searchTermsStringKey: 'optionTitle_linkPreview',
        allowedOptionKeys: ['LinkPreview'],
    },
    lazyFullModule,
    m => m.default
);
export default LinkPreviewOption;
